export default "__VITE_ASSET__6fd34ba4__"